import AppIcon from '../../../components/AppIcon';

const EmailMetricsCard = ({ metric }) => {
  return (
    <div className="bg-card rounded-lg p-6 border border-border">
      <div className="flex items-center justify-between mb-4">
        <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: `${metric?.color}20` }}>
          <AppIcon name={metric?.icon} size={24} color={metric?.color} />
        </div>
        <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
          metric?.changeType === 'increase' ?'bg-success/10 text-success' :'bg-error/10 text-error'
        }`}>
          <AppIcon 
            name={metric?.changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'} 
            size={14} 
          />
          <span>{metric?.change}</span>
        </div>
      </div>
      <div>
        <p className="text-sm text-muted-foreground mb-1">{metric?.title}</p>
        <p className="text-3xl font-bold text-foreground">{metric?.value}</p>
      </div>
    </div>
  );
};

export default EmailMetricsCard;